<template>
    <section class="brand-slider" :style="{ loading: loading }">
        <transition name="fade" appear>
            <template v-if="brands && brands.length">
                <div class="slider slider-brands">
                    <Splide :options="options">
                        <SplideSlide  v-for="(brand, key) in brands"
                                      :key="key"
                                      v-for-callback="{ key: key, array: brands, callback: loading = false }"
                        >
                            <a href="#"
                               class="js-ga-event"
                               data-page-area="partners"
                               data-type="image"
                               data-name=""
                               :data-text="brand.name"
                               data-action="href"
                               data-destination-url="#"
                            >
                                <figure class="item">
                                    <img :src="'/storage/' + brand.image"
                                         loading="lazy"
                                         :alt="brand.name"
                                         :data-splide-lazy="'/storage/' + brand.image"
                                    >
                                </figure>
                            </a>
                        </SplideSlide>
                    </Splide>
                </div>
            </template>
        </transition>

        <template v-if="loading">
            <ComponentLoader />
        </template>
    </section>
</template>

<script>
import { onMounted, ref } from 'vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

import ComponentLoader from '../globals/ComponentLoader'

import axios from 'axios'

export default {

    props: [
        'ids',
        'styles'
    ],

    components: {
        ComponentLoader,
        Splide,
        SplideSlide
    },

    setup(props) {

        const loading = ref(true)
        const brands  = ref(null)

        const options = {
            autoplay   : true,
            interval   : 3000,
            type       : 'loop',
            perPage    : 9,
            gap        : '75px',
            fixedWidth : '140px',
            arrows     : false,
            pagination : true,
            focus      : 'center',
            lazyLoad   : 'nearby',
        }

        onMounted( () => {
            axios.post('/api/get-brands', {
                brands: JSON.parse(props.ids)
            }).then( response => {
                if ( response.status === 200 )
                    brands.value = response.data.brands
                else
                    flash('Niečo sa pokazilo.', 'danger')
            }).catch( error => flash(error.message, 'danger') )
        })

        return {
            loading,
            brands,
            options
        }
    }
}
</script>
